import FAQ from './faq';
export default function findAConsultant() {
    find()
}

function find() {
    const form = document.querySelector('.consultant-locator-form');

    if (form) {
        const myLocation = form.querySelector('.my-location');
        const latInput = form.querySelector('input[name="Latitude"]');
        const longInput = form.querySelector('input[name="Longitude"]');
        const postCodeInput = form.querySelector('input[type="text"]');
        const mapContainer = document.querySelector('.map-container');
        const mapElememt = mapContainer.querySelector('#map');
        let mapLocationText = "";
        let geocoder = null;
        let infowindow = null;
        let map = null;
        let fieldValue = null;
        let type = null;

        myLocation.addEventListener("click", function (e) {
            e.preventDefault();
            getLocation();
            mapLocationText = this.getAttribute('data-location');

        });

        form.querySelector('button[type="submit"]').addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault();

            let input = postCodeInput.value;
            fieldValue = input;
            type = 'search'
            storeLocator(input);
        });
        function getLocation() {

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(success, error);
            }

            function success(pos) {
                const crd = pos.coords;
                form.classList.remove('location-error');

                // Check if Google Maps API is loaded
                if (typeof google === 'undefined' || !google.maps) {
                    console.error('Google Maps API not loaded');
                    form.classList.add('location-error');
                    return;
                }

                const geocoder = new google.maps.Geocoder();
                const latlng = { lat: crd.latitude, lng: crd.longitude };

                geocoder.geocode({ location: latlng }, function (results, status) {
                    if (status === "OK" && results.length > 0) {
                        const addressComponents = results[0].address_components;
                        const postcodeObj = addressComponents.find(function (comp) {
                            return comp.types.includes("postal_code");
                        });
                        if (postcodeObj) {
                            fieldValue = postcodeObj.long_name;
                            type = 'current';
                        } else {
                            console.log("No postcode found.");
                        }
                    } else {
                        console.error("Geocoding failed:", status);
                    }
                });

                setLocationData(crd.latitude, crd.longitude);
            }

            function error(err) {
                form.classList.add('location-error');
                console.warn(`ERROR(${err.code}): ${err.message}`);
            }
        }

        function initMap(currentLat, currentLong, locationsList) {
            if (currentLat == undefined && currentLong == undefined) {
                currentLat = 51.476529;
                currentLong = -0.182871;
            }

            geocoder = new google.maps.Geocoder();
            infowindow = new window.google.maps.InfoWindow();
            map = new google.maps.Map(mapElememt, {
                center: {
                    lat: currentLat,
                    lng: currentLong
                },
                zoom: 6,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });

            if (locationsList != undefined && locationsList.length > 0) {

                var bounds = new google.maps.LatLngBounds();

                for (let index = 0; index < locationsList.length; index++) {
                    const location = locationsList[index];
                    const lat = parseFloat(location.getAttribute('data-lat'));
                    const long = parseFloat(location.getAttribute('data-lon'));
                    const icon = location.getAttribute('data-map-pin');
                    let iconSettings;

                    if (icon != "") {
                        iconSettings = {
                            url: icon,
                            scaledSize: new google.maps.Size(26, 48), // default marker size
                            origin: new google.maps.Point(0, 0), // origin
                            anchor: new google.maps.Point(13, 48) // anchor
                        };
                    }


                    var myLatLng = new google.maps.LatLng(lat, long);

                    let marker = new google.maps.Marker({
                        icon: iconSettings,
                        position: myLatLng,
                        animation: google.maps.Animation.DROP,
                        label: {
                            text: location.getAttribute('id'),
                            color: 'rgba(0, 0, 0, 0)',
                        },
                        map: map
                    });

                    bounds.extend(myLatLng);
                    attachClickHandler(marker)
                    map.fitBounds(bounds);
                }

                if (postCodeInput.value != "") {
                    mapLocationText = postCodeInput.value;
                }

                mapContainer.classList.remove('hidden');

                window.scroll({
                    top: mapContainer.getBoundingClientRect().top + document.documentElement.scrollTop - 100,
                    behavior: "smooth"
                });
            }
        }

        // Map will be initialized when results are loaded (line 204)
        // Removed premature initMap() call to avoid "google is not defined" error

        function attachClickHandler(marker) {
            google.maps.event.addListener(marker, 'click', function () {


                var text = '#' + marker.label.text;
                var elem = document.querySelector(text);

                window.scroll({
                    top: elem.getBoundingClientRect().top + document.documentElement.scrollTop - 100,
                    behavior: "smooth"
                });

                if (!elem.classList.contains('active')) {
                    elem.click();
                }
            });
        }

        function storeLocator(address) {
            let locale = document.querySelector('html').getAttribute("lang");

            var str = locale.substring(3, 5);
            
            // Initialize geocoder if not already initialized
            if (!geocoder && typeof google !== 'undefined') {
                geocoder = new google.maps.Geocoder();
            }
            
            if (!geocoder) {
                console.error('Google Maps API not loaded');
                form.classList.add('location-error');
                return;
            }
            
            geocoder.geocode({
                'address': address + ', ' + str,
                'region': str
            }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    form.classList.remove('location-error');
                    setLocationData(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                } else {
                    form.classList.add('location-error');
                }
            });
        }

        function setLocationData(lat, long) {
            latInput.value = lat;
            longInput.value = long;

            var formData = new FormData(form);
            let resultsContainer = document.querySelector('.result-container');

            fetch('/umbraco/surface/FindAConsultant/GetShowroomsWithConsultant', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
                .then(response => response.text())
                .then(html => {
                    resultsContainer.innerHTML = html
                    FAQ();

                    let locationList = resultsContainer.querySelectorAll('.accordion');
                    initMap(lat, long, locationList);
                })
                .catch(error => console.log(error.message))
                .finally();

            //added timer to allow the map api to return correct results
            setTimeout(updateDataLayer, 10000);
        }

        function updateDataLayer() {

            // Push data to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'location',
                'type': type,
                'fieldValue': fieldValue
            });
        }

        function filterResults() {
            const stockistFilterContainer = document.querySelector(".stockist-filters");

            if (stockistFilterContainer) {
                let stockistFilters = document.querySelectorAll(".stockist-filter");

                stockistFilters.forEach(element => {
                    element.addEventListener("click", function (e) {

                        let stockists = document.querySelectorAll('.stockists .accordion');
                        let values = element.value.split(',');
                        let elementList = [];

                        stockists.forEach(stockist => {
                            if (values.includes(stockist.getAttribute('data-map-id'))) {
                                elementList.push(stockist);
                            }
                            else {
                                stockist.classList.remove('active');
                                var panel = stockist.nextElementSibling;
                                panel.classList.remove("active");

                            }
                        });

                        initMap(parseFloat(latInput.value), parseFloat(longInput.value), elementList);
                    });
                });
            }
        }

        filterResults();
    }
}